import { call, put, takeLatest } from "redux-saga/effects";
import { transfer, setTransfer, transferError } from "./slice";
import { transferApi } from "./api";

function* handleTransfer(action) {
  try {
    const response = yield call(transferApi, action.payload);

    if (response.success) {
      // Use backend message if provided, otherwise fallback to generic
      const message = response.message || "Transfer successful!";
      yield put(setTransfer({ message, success: true }));
    } else {
      // Use backend error message if provided
      const error = response.error || "Payment failed";
      yield put(transferError({ error }));
    }
  } catch (error) {
    yield put(transferError({ error: error.message || "Transfer failed" }));
  }
}

export default function* transferSaga() {
  yield takeLatest(transfer.type, handleTransfer);
}
